import { createPortal } from 'react-dom';
import React, { useEffect, useState } from 'react';

export default function Portal({ children, containerId = 'portal-root' }) {
    const [container, setContainer] = useState(null);

    useEffect(() => {
        let el = document.getElementById(containerId);
        let created = false;
        if (!el) {
            el = document.createElement('div');
            el.id = containerId;
            el.style.position = 'relative';
            document.body.appendChild(el);
            created = true;
        }
        setContainer(el);
        return () => {
            if (created && el.parentNode) {
                el.parentNode.removeChild(el);
            }
        };
    }, [containerId]);

    if (!container) return null;
    return createPortal(children, container);
}
